import React from "react";
import { useState } from "react";
import { Table, Space, Popconfirm, message, Button } from "antd";
import moment from "moment";
import {
  getBaseUrl,
  doPostRequest,
} from "../../helpers/requestHelpers";

const CustomCelebrations = ({ getAdminsQuery }) => {
  const [pagination, setPagination] = useState({
    position: ["bottomCenter"],
    pageSize: 50,
    pageSizeOptions: ["10", "20", "50", "100"],
    showSizeChanger: true,
  });
  
  const removeAdminClicked = async (admin, refetchAdmins) => {
    try {
      const updateResponse = await doPostRequest(
        `${getBaseUrl()}/api/updatePartialAdmins`,
        { user_ids: [admin.user_id], feature: 'custom_celebration', value: false },
        (errorType) => {
          // TODO: Not doing anything with error type here TODO_TRELLO_1136
        }
      );

      if (updateResponse.success) {
        message.success(`Successfully updated admin: ${admin.first_name} ${admin.last_name}`);
        refetchAdmins();
      } else if (updateResponse.error) {
        throw new Error(updateResponse.error);
      } else {
        throw new Error("Failed to update admin");
      }
    } catch (error) {
      const errorMessage = JSON.parse(error.message);
      message.error(errorMessage.error);
    }
  };

  if (getAdminsQuery.isLoading) return <p>Loading...</p>;
  if (getAdminsQuery.error) return <p>Error loading admins</p>;

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      key: "employee_name",
      render: (_, admin) => (
        <div>
          {admin.first_name} {admin.last_name}
        </div>
      ),
    },
    {
      title: "Employee Email",
      dataIndex: "email",
      key: "email",
      render: (_, admin) => <div>{admin.email}</div>,
    },
    {
      title: "Date Added",
      dataIndex: "created_at",
      key: "created_at",
      render: (_, admin) => moment.unix(admin.created_at).format("MM/DD/YYYY"),
    },
    {
      title: "Action",
      key: "action",
      render: (_, admin) => (
        <Space size="middle">
          <Popconfirm
            title={`Are you sure you want to remove ${admin.first_name} ${admin.last_name} as a custom celebration admin?`}
            onConfirm={() => removeAdminClicked(admin, getAdminsQuery.refetch)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>Remove as admin</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <p>Custom celebration admins have permissions to create new custom celebrations for their team.</p>
      <Table
        columns={columns}
        dataSource={getAdminsQuery.data.admins}
        pagination={{
          ...pagination,
          onChange: (page, pageSize) => {
            setPagination((prev) => ({ ...prev, pageSize }));
          },
        }}
      />
    </>
  );
};

export default CustomCelebrations; 